import { useMutation, useQuery } from "@tanstack/react-query";
import { Sparkles } from "lucide-react";
import { api } from "../lib/api";

type DemoInfo = { enabled: boolean };

// Shown only on the public demo Worker (GET /api/auth/demo answers enabled: false everywhere else).
// The button asks the server to create a demo session; no credentials ever reach the browser.
export function DemoLoginHint({ onSignedIn }: { onSignedIn: () => void }) {
  const demo = useQuery({ queryKey: ["demo-login"], queryFn: () => api<DemoInfo>("/api/auth/demo"), retry: false, staleTime: Infinity });
  const start = useMutation({ mutationFn: () => api("/api/auth/demo", { method: "POST" }), onSuccess: onSignedIn });
  if (!demo.data?.enabled) return null;
  return <div className="demo-hint" role="note">
    <Sparkles size={14} /> Demo workspace with sample data. Some actions are turned off.
    <br /><button type="button" className="link-button" disabled={start.isPending} onClick={() => start.mutate()}>{start.isPending ? "Opening the demo…" : "Open the demo"}</button>
    {start.error && <div className="form-error">{start.error.message}</div>}
  </div>;
}
